import { useRecoilValue } from 'recoil';
import routes from './routes';
import { SetRoutes } from 'components';
import { getPage } from 'hooks/useUser';

const MainPages = () => {

  const { ability = {} } = useRecoilValue(getPage);
  // if (!Object.keys(ability)?.length) return '...loading';

  const conditionOne = (item) => (item?.name === 'edit-invoice' && ability?.can_update);
  const conditionTwo = (item) => (item?.name === 'new-invoice' && ability?.can_create);

  const allRoutes = routes?.reduce((acc, item) => {
    if (!item?.name) acc.push(item);
    else if (conditionOne(item) || conditionTwo(item)) acc.push(item);
    return acc;
  },[]) || [];

  return (
    <>
      <SetRoutes routes={allRoutes} />
    </>
  );
};

export default MainPages;
